export default __webpack_public_path__ + "static/media/img_myhome_show.0db3eb98.jpg";